import {
  USER_CREATE_REQUEST,
  USER_SUCCESS,
  USER_ERROR,
  USER_UPDATE,
  USER_PROFILE,
  USER_PERMISSION_SET,
  USER_PROFILE_IMG_SET,
  USER_PROFILE_IMG_GET,
  USER_PROFILE_IMG_REMOVE
} from './user.type'

import User from '@/resources/models/User'
import ApiRest from '@/api/api-rest'
import Permissions from '@/resources/models/Permissions'

const state = {
  userStatus: '',
  userProfile: JSON.parse(localStorage.getItem('user_profile')) || {},
  userRoles: {},
  userPermissions: {},
  userAccount: new User('id', JSON.parse(localStorage.getItem('user_profile'))),
  userProfileImg: ''
}

const getters = {
  userStatus: state => state.userStatus,
  userProfile: state => state.userProfile,
  userRoles: state => state.userProfile.roles,
  userPermissions: state => state.userPermissions,
  userAccount: state => state.userAccount,
  userProfileImg: state => state.userProfileImg
}

// Best Practice - updates state
const mutations = {
  [USER_CREATE_REQUEST]: state => (state.userStatus = 'loading'),
  [USER_SUCCESS]: state => (state.userStatus = 'saved'),
  [USER_ERROR]: (state, errMsg) => {
    state.userStatus = 'error'
  },
  [USER_PROFILE]: (state, user) => {
    state.userStatus = 'saved'
    state.userProfile = JSON.parse(localStorage.getItem('user_profile'))
    state.userRoles = state.userProfile.roles
    state.userAccount = _.assignIn(state.userAccount, user.account)
  },
  [USER_PERMISSION_SET]: (state, permissions) => {
    if (!(state.userPermissions instanceof Permissions)) {
      state.userPermissions = new Permissions()
    }
    state.userPermissions.setPermissions(permissions)
  },
  [USER_PROFILE_IMG_SET]: (state, userProfileImg) => {
    state.userProfileImg = userProfileImg
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [USER_PROFILE] (context, account) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/user?email=${account.email}`)
        .then(({ data }) => {
          localStorage.setItem('user_profile', JSON.stringify(data))
          context.commit(USER_PROFILE, { account: data })
          context.commit(USER_PROFILE_IMG_SET, data.profile_img)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(USER_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [USER_PERMISSION_SET] (context, permissions) {
    context.commit(USER_PERMISSION_SET, permissions)
  },
  [USER_CREATE_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(USER_CREATE_REQUEST)
      ApiRest()
        .post('/registration', {
          firstname: payload.firstname,
          lastname: payload.lastname,
          description: payload.description,
          email: payload.email,
          password: payload.password,
          active: payload.active,
          roles: payload.roles
        })
        .then(resp => {
          context.commit(USER_SUCCESS, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(USER_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [USER_UPDATE] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(USER_CREATE_REQUEST)
      ApiRest()
        .put(`/user?id=${payload.id}`, {
          email: payload.email,
          firstname: payload.firstname,
          lastname: payload.lastname,
          description: payload.description,
          active: payload.active,
          roles: payload.roles
        })
        .then(resp => {
          context.commit(USER_SUCCESS, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(USER_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [USER_PROFILE_IMG_SET] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post(`/user/image/${payload.userId}`, {
          profileImg: payload.profileImg
        })
        .then(resp => {
          context.commit(USER_PROFILE_IMG_SET, payload.profileImg)
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [USER_PROFILE_IMG_GET] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(`/user/image/${payload.userId}`)
        .then(({ data }) => {
          context.commit(USER_PROFILE_IMG_SET, data.profileImg)
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [USER_PROFILE_IMG_REMOVE] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`/user/image/${payload.userId}`)
        .then(resp => {
          context.commit(USER_PROFILE_IMG_SET, '')
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user/user.module.js